import { defineMessages } from 'react-intl'

/** Trip Planner UI actions and labels — `docs/product-taxonomy.md` §10. */
const tripPlannerGlossaryMessages = defineMessages({
  addToTrip: {
    id: 'BR_KZw03BufNxuYb89An',
    defaultMessage: 'Add to trip',
  },
  saveToTrip: {
    id: 'VTTsrzGbwvW6-qa4s13_',
    defaultMessage: 'Save to trip',
  },
  removeFromTrip: {
    defaultMessage: 'Remove from trip',
    id: 'eCiiKHhCQp6RhnWmqEDH',
  },
  buildMyTrip: {
    id: 'pNkA5wRSo3yds4TDb79B',
    defaultMessage: 'Build my trip',
  },
  createNewTrip: {
    id: '6sC1SRhnrQSVaxyO1KmY',
    defaultMessage: 'Create new trip',
  },
  createTrip: {
    defaultMessage: 'Create trip',
    id: 'KNvG6QrCCzxX0sz-0Dwy',
  },
  deleteTrip: {
    id: 'AWPPJhbrAK3GM9ED9eXg',
    defaultMessage: 'Delete trip',
  },
  leaveTrip: {
    id: 'ABSmIN45uJvaAgQ1AuP1',
    defaultMessage: 'Leave trip',
  },
  viewTripPlan: {
    id: 'DaWuzN5uZ8KhtII7opV_',
    defaultMessage: 'View trip plan',
  },
  changeTripImage: {
    defaultMessage: 'Change trip image',
    id: 'L7YRrlhUeFwvkYFcUw8I',
  },
  nameYourNewTrip: {
    defaultMessage: 'Name your new trip',
    id: 'Y9cGtZfJAheCyAD6mzlD',
  },
  tripItinerary: {
    defaultMessage: 'Trip itinerary',
    id: 'bggPj5o2_5C2ayK-JRUW',
  },
  tripStarts: {
    defaultMessage: 'Trip starts',
    id: 'TsScHutgy_XaBvlKWDcX',
  },
  tripPlans: {
    defaultMessage: 'Trip plans',
    id: 'X3S2PMCdtRWUb8bXHnw-',
  },
  trips: {
    defaultMessage: 'Trips',
    id: '0J4eTLz_ALqDXc6V-1hx',
  },
})

export default tripPlannerGlossaryMessages
